<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import PRPD from './PRPD/PRPD.vue'
import SPDG from './SPDG/SPDG.vue'
import SPDH from './SPDH/SPDH.vue'
import ILPF from './ILPF/ILPF.vue'
import SAF from './SAF/SAF.vue'
import FP from './FP/FP.vue'
import MRPA from './MRPA/MRPA.vue'
import TI from './TI/TI.vue'

export default {
  components: {
    Label,
    AppDisplay,
    PRPD,
    SPDG,
    SPDH,
    ILPF,
    SAF,
    FP,
    MRPA,
    TI
  },
  props: {
    praticas: {
      type: Object
    }
  },
  computed: {
    hasAnyPratica () {
      return this.praticas.praticaSustentavelPRPD ||
      (this.praticas.praticaSustentavelSPDG && this.praticas.praticaSustentavelSPDG.length) ||
      (this.praticas.praticaSustentavelSPDH && this.praticas.praticaSustentavelSPDH.length) ||
      this.praticas.praticaSustentavelILPF ||
      this.praticas.praticaSustentavelSAF ||
      this.praticas.praticaSustentavelFP ||
      this.praticas.praticaSustentavelMRPA ||
      this.praticas.praticaSustentavelTI
    }
  }
}

</script>

<template>
  <div>
    <div v-if="hasAnyPratica">
      <el-collapse @change="() => {}">
        <el-collapse-item v-if="praticas.praticaSustentavelPRPD" title="Práticas para Recuperação de Pastagens Degradadas (PRPD)" name="PRPD">
          <PRPD :pratica="praticas.praticaSustentavelPRPD" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelSPDG && praticas.praticaSustentavelSPDG.length" title="Sistema de Plantio Direto de Grãos (SPDG)" name="SPDG">
          <SPDG :praticas="praticas.praticaSustentavelSPDG" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelSPDH && praticas.praticaSustentavelSPDH.length" title="Sistema de Plantio Direto de Hortaliças (SPDH)" name="SPDH">
          <SPDH :praticas="praticas.praticaSustentavelSPDH" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelILPF" title="Integração Lavoura-Pecuária-Floresta (ILPF)" name="ILPF">
          <ILPF :pratica="praticas.praticaSustentavelILPF" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelSAF" title="Sistemas Agroflorestais (SAF)" name="SAF">
          <SAF :pratica="praticas.praticaSustentavelSAF" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelFP" title="Florestas Plantadas (FP)" name="FP">
          <FP :pratica="praticas.praticaSustentavelFP" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelMRPA" title="Manejo de Resíduos da Produção Animal (MRPA)" name="MRPA">
          <MRPA :pratica="praticas.praticaSustentavelMRPA" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelTI" title="Terminação intensiva (TI)" name="TI">
          <TI :pratica="praticas.praticaSustentavelTI" />
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-else>
      <span>Nenhuma prática exercida.</span>
    </div>
  </div>

</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/Praticas.vue